<template>
  <div>
    <b-card no-body>
      <div class="m-2">
        <b-row>
          <b-col cols="12">
            <b-row class="pb-1">
              <b-col cols="12">
                <h4>Danh sách gửi feedback</h4>
              </b-col>
            </b-row>
            <b-row class="pb-1">
              <b-col cols="2">
                <b-form-input v-model="fromDate" placeholder="Nhập ngày bắt đầu " type="date"
                              v-on:keydown.enter="quickSearch"/>
              </b-col>
              <b-col cols="2">
                <b-form-input v-model="toDate" placeholder="Nhập ngày kết thúc " type="date"
                              v-on:keydown.enter="quickSearch"/>
              </b-col>
              <b-col cols="2">
                <b-button class="btn-sm " variant="primary" @click="downloadFeed()">
                  <feather-icon class="align-text-top" icon="ExportIcon" size="16"/>
                  Xuất excel
                </b-button>
              </b-col>
              <b-col cols="6">
                <b-input-group>
                  <b-form-input v-model="searchQuery" placeholder="Tìm kiếm " v-on:keydown.enter="quickSearch()"/>
                  <b-input-group-append is-text role="button" @click="quickSearch()">
                    <feather-icon icon="SearchIcon"/>
                  </b-input-group-append>
                </b-input-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <vue-good-table :columns="options.fields" :isLoading.sync="isLoading" :line-numbers="true" :pagination-options="{perPage: serverParams.pageSize,enabled: true,perPageDropdown: [20,50,100],dropdownAllowAll: false}"
                                :rows="items" :totalRows="totalRecords"
                                mode="remote"
                                @on-page-change="onPageChange" @on-sort-change="onSortChange"
                                @on-column-filter="onColumnFilter"
                                @on-per-page-change="onPerPageChange">
                  <template slot="table-row" slot-scope="props">
                    <!-- Column: Action -->
                    <span v-if="props.column.field === 'action'">
                      <span>
                        <!-- <b-button variant="primary" class="btn-icon" size="sm" @click="Edit(props.row, props.row.id)">
                          <feather-icon icon="Edit2Icon" />
                        </b-button> -->
                        <b-button class="btn-icon" size="sm" style="margin-left: 6px" variant="danger"
                                  @click="DeleteItem(props.row, props.row.id)">
                          <feather-icon icon="TrashIcon"/>
                        </b-button>
                      </span>
                    </span>
                  </template>
                </vue-good-table>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>
    </b-card>

    <!-- <b-modal size="xl" id="modal-edit" :title="getTitle()" @ok="handleOk">
      <form ref="form">
        <b-row>
          <b-col cols="12">
            <b-form-group>
              <label>Email <span class='text-danger'>*</span></label>
              <b-form-input type="email" required :state="validateState('email')" v-model="currentItem.email"
                placeholder="Nhập email" />
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group label="Mô tả danh mục">
              <b-form-textarea placeholder="Mô tả danh mục" rows="8" k-max-length="500"
                v-model="currentItem.description" max-rows="20" />
            </b-form-group>
          </b-col>
        </b-row>
      </form>
    </b-modal> -->

  </div>
</template>

<script>

import {ValidationObserver, ValidationProvider} from "vee-validate";
import {required} from "@validations";
import vSelect from "vue-select";
import {VueGoodTable} from "vue-good-table";
import {
  BAvatar,
  BBadge,
  BButton,
  BCard,
  BCol,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  BFormDatepicker,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormTextarea,
  BInputGroup,
  BInputGroupAppend,
  BLink,
  BMedia,
  BModal,
  BPagination,
  BRow,
  BTable,
  BTooltip
} from "bootstrap-vue";
import useJwt from "@/auth/jwt/useJwt";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import "@core/scss/vue/libs/vue-good-table.scss";
import Select2 from "v-select2-component";
import moment from "moment";


export default {
  name: "adminTopic",
  components: {
    BFormDatepicker,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    FeatherIcon,
    BModal,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BFormSelect,
    VueGoodTable,
    Select2,
    BFormTextarea,
    BInputGroup, BInputGroupAppend
  },
  methods: {
    validateState() {
      if (!this.isSubmit) return null;
      if (!this.currentItem.email || !this.validateEmail(this.currentItem.email)) return false;
      else return true;
      return null;
    },
    validateEmail(email) {
      if (/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/.test(email)) {
        return true;
      } else {
        return false;
      }
    },
    getTitle() {
      if (this.editMode) {
        return "Cập nhật email ";
      } else {
        return "Thêm mới email ";
      }
    },

    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },

    onPageChange(params) {
      this.updateParams({page: params.currentPage});
      this.loadFeedback();
    },
    onPerPageChange(params) {
      this.updateParams({pageSize: params.currentPerPage});
      this.loadFeedback();
    },
    onSortChange(params) {
      this.updateParams({
        sort: params,
      });
      this.loadFeedback();
    },
    onColumnFilter(params) {
      this.serverParams.page = 1;
      this.updateParams(params);
      console.log(this.serverParams);
      this.loadFeedback();
    },

    New() {
      this.currentItem = {};
      this.editMode = false;
      this.modal_title = "Thêm mới email ";
      this.$bvModal.show("modal-edit");
    },

    async Edit(item) {
      this.currentItem = item;
      this.editMode = true;
      this.modal_title = "Cập nhật email";
      this.$bvModal.show("modal-edit");
    },

    async DeleteItem(item, index, button) {
      this.currentItem = item;
      const url = `portal/feedback/${item.id}`;
      let resModal = await this.$bvModal.msgBoxConfirm(
          "Vui lòng xác nhận bạn muốn xoá dữ liệu email",
          {title: "Please Confirm", size: "sm"}
      );
      if (resModal) {
        try {
          this.loading(true);
          let res = await useJwt.delete(url);
          if (res.data.code == 200) {
            this.loadFeedback();
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Xoá email thành công!",
                icon: "CheckSquareIcon",
                variant: "primary",
              },
            });
          }
          this.loading(false);
        } catch (error) {
          this.loading(false);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Lỗi xoá email ",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        }
      }
    },

    async isValid(item) {
      if (!item.email) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Email không được để trống",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
        return false;
      }

      return true;
    },
    async loadFeedback() {
      try {
        this.loading(true);
        this.serverParams.columnFilters.fromDate = this.fromDate;
        this.serverParams.columnFilters.toDate = this.toDate;
        let data = {
          ...this.serverParams,
          columnFilters: {
            ...(this.serverParams.columnFilters ? this.serverParams.columnFilters : [])
          }
        }
        if (data.columnFilters.created_date != undefined) {
          delete data.columnFilters['created_date_']
        }
        useJwt.post("portal/feedbacks", data).then((response) => {
          var result = response.data;
          if (result.code == 200) {
            this.items = result.result;
            this.totalRecords = result.totalRecords;
          }
          this.isLoading = false;
          this.loading(false);
        });
      } catch (ex) {
        this.loading(false);
      }
    },
    async quickSearch() {
      this.serverParams.columnFilters.searchQuick = this.searchQuery;
      this.loadFeedback();
    },

    dateFormat(v) {
      return moment(v, 'YYYYMMDDHHmmss').format('DD/MM/YYYY hh:mm:ss')
    },
    async downloadFeed() {
      try {
        this.loading(true);
        await useJwt.getFile("portal/downloadFeedexcel?fromDate=" + this.fromDate + "&toDate=" + this.toDate + "&filter=" + this.searchQuery, 'feedback.xlsx');
        this.loading(false);
      } catch (err) {
        this.loading(false);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "File không đúng hoặc không còn tồn tại.",
            icon: "AlertTriangleIcon",
            variant: "danger"
          },
        });
      }
    },
  },

  mounted() {
    const dtNow = new Date();
    const month = dtNow.getMonth() + 1;
    this.toDate = dtNow.getFullYear() + "-" + (month > 9 ? month : "0" + month) + "-" + (dtNow.getDate() > 9 ? dtNow.getDate() : "0" + dtNow.getDate());
    const dtFrom = new Date();
    dtFrom.setDate(dtFrom.getDate() - 7);
    const fromMonth = dtFrom.getMonth() + 1;
    this.fromDate = dtFrom.getFullYear() + "-" + (fromMonth > 9 ? fromMonth : "0" + fromMonth) + "-" + (dtFrom.getDate() > 9 ? dtFrom.getDate() : "0" + dtFrom.getDate());
    this.loadFeedback();
    this.isSubmit = false;
  },
  data() {
    return {
      isLoading: false,
      isSubmit: false,
      totalRecords: 0,
      totalRecordSubs: 0,
      items: [],
      editMode: false,
      totalItem: 0,
      searchQuery: "",
      toDate: null,
      fromDate: null,
      currentItem: {},
      serverParams: {
        "columnFilters": {},
        "sort": [
          {"field": "created_date", "type": "desc"}
        ],
        "page": 1,
        "pageSize": 50,
        "lang": 1
      },
      required,
      options: {
        fields: [

          {
            field: "newName",
            filterOptions: {enabled: false, placeholder: ""},
            label: "Chủ đề",
            required: true,
            disabled: true,
          },
          {
            field: "created_date",
            filterOptions: {enabled: false, placeholder: ""},
            label: "Ngày gửi",
            type: 'date',
            dateInputFormat: 'yyyy-MM-dd\'T\'HH:mm:ss',
            dateOutputFormat: 'dd/MM/yyyy HH:mm:ss',
            disabled: true
          },
          {
            field: "created_at",
            filterOptions: {enabled: false, placeholder: ""},
            label: "Người đề xuất",
            required: true,
            disabled: true,
          },
          {
            field: "contents",
            filterOptions: {enabled: false, placeholder: ""},
            label: "Nội dung đề xuất",
            required: true,
            disabled: true,
          },
          {field: "action", label: "Cài đặt", width: "120px"}
        ]
      },
    };
  },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
<style lang="scss">
select[readonly].select2 + .select2-container {
  pointer-events: none;
  touch-action: none;

  .select2-selection {
    background: #eee;
    box-shadow: none;
  }

  .select2-selection__arrow,
  .select2-selection__clear {
    display: none;
  }
}

table.vgt-table td {
  min-width: 100px;
}
</style>
